import React, { useEffect, useState, useContext } from "react";
import { Paper, Autocomplete, Button, TextField, Box } from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2";
import AddIcon from "@mui/icons-material/Add";
import Process from "../components/Process";
import uuid from "react-uuid";
import { useSelector, useDispatch } from "react-redux";
import Modal from "@mui/material/Modal";
import { AuthContext } from "../../context/AuthContext";
import { CircularProgress } from "@mui/material";
import Backdrop from "@mui/material/Backdrop";
import { useSnackbar } from "notistack";
import axios from "axios";

import AddStation from "../components/AddStation";

const style = {
	position: "absolute",
	top: "50%",
	left: "50%",
	transform: "translate(-50%, -50%)",
	maxWidth: 800,
	width: "90%",
	bgcolor: "background.paper",
	border: "2px solid #000",
	boxShadow: 24,
	p: 4,
	mx: "auto",
};

const OrderProcesses = () => {
	const [open1, setOpen1] = useState(false);
	const handleOpen1 = () => setOpen1(true);
	const handleClose1 = () => setOpen1(false);
	const [isLoading, setIsLoading] = useState(false);
	const auth = useContext(AuthContext);
	const { enqueueSnackbar } = useSnackbar();
	const [types, setTypes] = useState([]);
	const [orderType, setOrderType] = useState(null);
	const [process, setProcess] = useState([]);
	const updater = useSelector((state) => state.updateReducer.orderProcess);

	const getOrderTypes = async () => {
		setIsLoading(true);
		await axios
			.post(
				"/api/v1/laboratorys/get-orderTypes",
				{
					onlyName: false,
					page: 0,
					rowCount: 0,
				},
				{
					headers: {
						authorization: auth.token,
					},
				}
			)
			.then((response) => {
				setTypes(response.data.data.result);
			})
			.catch((e) => {
				const messages = e.response.data.message.message;

				Array.isArray(messages)
					? messages.map((message) => {
							enqueueSnackbar(message, { variant: "error" });
					  })
					: enqueueSnackbar(messages, { variant: "error" });
			})
			.finally(() => setIsLoading(false));
	};

	const getOrderTypeProcess = async () => {
		setIsLoading(true);
		axios
			.post(
				"/api/v1/laboratorys/get-orderType-process",
				{
					orderTypeId: orderType.id,
				},
				{
					headers: {
						authorization: auth.token,
					},
				}
			)
			.then((response) => {
				setProcess(response.data.data);
			})
			.catch((e) => {
				const messages = e.response.data.message.message;
				setProcess([]);
				Array.isArray(messages)
					? messages.map((message) => {
							enqueueSnackbar(message, { variant: "error" });
					  })
					: enqueueSnackbar(messages, { variant: "error" });
			})
			.finally(() => setIsLoading(false));
	};

	//getting order types with only names and IDs
	useEffect(() => {
		getOrderTypes();
	}, []);

	//getting order type process
	useEffect(() => {
		if (orderType) getOrderTypeProcess();
	}, [orderType, updater]);

	return (
		<React.Fragment>
			<Backdrop
				sx={{
					color: "#fff",
					zIndex: (theme) => theme.zIndex.drawer + 1,
				}}
				open={isLoading}
			>
				<CircularProgress color="inherit" />
			</Backdrop>

			<Modal open={open1} onClose={handleClose1}>
				<Box sx={style}>
					<AddStation
						close={handleClose1}
						id={orderType && orderType.id}
					/>
				</Box>
			</Modal>

			<Paper sx={{ flexGrow: 1, maxWidth: 1200, p: 2 }}>
				<Grid container spacing={2} alignItems={"stretch"}>
					<Grid xs={12} md={6}>
						<Autocomplete
							noOptionsText="موردی یافت نشد"
							label="نوع کار"
							variant="outlined"
							value={orderType}
							options={types}
							getOptionLabel={(option) => option.name}
							renderInput={(params) => (
								<TextField
									{...params}
									label="نوع کار"
									variant="outlined"
								/>
							)}
							onChange={(event, value) => setOrderType(value)}
							fullWidth
						/>
					</Grid>
					{orderType && (
						<Grid xs={12} md={6}>
							<Button
								variant="contained"
								color="secondary"
								fullWidth
								size="large"
								onClick={handleOpen1}
								sx={{ height: "100%" }}
							>
								<AddIcon />
								اضافه کردن مرحله کاری
							</Button>
						</Grid>
					)}
				</Grid>
				{orderType && (
					<Grid container spacing={2} sx={{ mt: 3 }}>
						{process.map((station) => {
							return (
								<Process
									key={station.id}
									idP={station.id}
									stationNameP={station.stationName}
									oneJaw1To7P={station.oneJaw1To7}
									twoJaw1To7P={station.twoJaw1To7}
									oneJaw7To14P={station.oneJaw7To14}
									twoJaw7To14P={station.twoJaw7To14}
									twoJaw14To21P={station.twoJaw14To21}
									twoJaw21To28P={station.twoJaw21To28}
									oneJawFullP={station.oneJawFull}
									twoJawFullP={station.twoJawFull}
								/>
							);
						})}
					</Grid>
				)}
			</Paper>
		</React.Fragment>
	);
};

export default OrderProcesses;
